function useMaintenance() {
  const isInMaintenance = window.location.pathname === '/maintenance';

  return isInMaintenance;
}

export default useMaintenance;
